import React, { useEffect, useState } from 'react';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import AppURL from '../../../../constants/AppURL';
import { ToastWarning } from '../../../../constants/Toast';
import { handleSelectBox } from '../../../../helpers/handleChange';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { SalesProductListReducer, ProductMaster, defaultEmployeeData, OnAmtList } from '../../../../helpers/models/Models';
import { SALES_PRODUCT_LIST } from '../../../../store/inventorySlice';
import { MasterCategoryOptions, ProductSalesOptions, ProductStoreOptions, SubCategoryOptions } from '../../../../constants/Options';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { fetchDataFromApi } from '../../../../helpers/api';
import SalesDetailsDrawer from './widgets/SalesDetailsDrawer';
import { useDispatch } from 'react-redux';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { useFormik } from 'formik';
import useFetchSubData from '../../../../helpers/useSubFetch';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import { salesDataPost } from '../../../../helpers/submitDataOnServer';
import { formatMoney } from '../../../../helpers/DateFormat';
interface SalesFormFormViewProps {
    data: {
        results: ProductMaster[]
    } | null;
    loading: boolean;
}
const ProductSaleCreateView: React.FC<SalesFormFormViewProps> = ({ data }) => {
    const { SalesProductList } = useSelector((state: RootState) => state.inventory);
    const masterCategoryOptions = MasterCategoryOptions(data?.results);
    const [employeeData, setOnEmployeeData] = useState();
    const [open, onClose] = useState(false);
    const dispatch = useDispatch();
    const nepDate = NepNowDateFormat();
    const [onAmtList, setOnAmtList] = useState<OnAmtList>({
        total_product_amt: 0,
        final_total_amt: 0,
        vatAmt: 0, // Initialize vatAmt here as well
    });
    const initialValues = {
        master_category: "3",              // Corresponds to "name"
        pur_sale_date: nepDate || "",
        product_category: "",        // Corresponds to "name_nep"
        product: "",
        sub_master: "",
        store: "",
        payment_mode: "0",
        sales_rate: "0",
        sales_qty: "",
        tot_amt: "",
        remarks: "",
        vat_amt: "0",
        dis_amt: "0",
        dis_per: "0",
        member_sn: "",
        total_purchase: "",
        sel_tot_amt: "0",
        pro_name: "",

    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: proIssuevalidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            onClose(false);
            const totalIssuedQty = SalesProductList?.filter(item => item?.product === parseInt(values?.product))
                .reduce((sum, item) => sum + item.sales_qty, 0);

            const remainingIssuableQty = parseInt(values.total_purchase) - totalIssuedQty;
            if (parseInt(values.sales_qty) > remainingIssuableQty) {
                ToastWarning({ message: "Issue Quantity exceeds available stock" });
                return;
            }
            const newProducts: SalesProductListReducer[] = [
                {
                    master_category: parseInt(values.master_category) || 0,
                    pur_sale_date: values.pur_sale_date,
                    product_category: parseInt(values.product_category) || 0,
                    product: parseInt(values.product) || 0,
                    store: values.store || 0,
                    sales_rate: parseFloat(values.sales_rate || '0'),
                    remarks: values.remarks,
                    sales_qty: parseInt(values.sales_qty),
                    vat_amt: parseFloat(values.vat_amt || '0'),
                    dis_amt: parseFloat(values.dis_amt || '0'),
                    dis_per: parseFloat(values.dis_per || '0'),
                    tot_amt: formatMoney(onAmtList.final_total_amt??0),
                    payment_mode: 0,
                    pro_name: values.pro_name,
                    sales_tot_amt: parseFloat(onAmtList.final_total_amt?.toString()),
                    member_sn: parseInt(values.member_sn)
                }
            ];
            try {
                if (parseInt(values.sales_qty) > 0) {
                    try {
                        dispatch(SALES_PRODUCT_LIST(newProducts));
                        action.resetForm();
                    } catch (error) {
                        console.error("Error saving product purchase:", error);
                    }
                } else {
                    ToastWarning({ message: "Issue Qty more than 0" });
                }
            } catch (error) {
                console.error("Error saving product purchase:", error);
            }
        },
    });

    const { data: sub_category, loading, error } = useFetchSubData(AppURL.InventoryURL + "inventory/product/category/master/wise/list/?product_master=" + values.master_category, values.master_category);
    const subCategoryOptions = SubCategoryOptions(sub_category?.sub_category);
    const { data: pro_member_data, loading: pro_member_loading, error: pro_member_error, refetch } = useFetchSubData(AppURL.InventoryURL + "inventory/product/with/member/options/list/view/?sub_master=" + values.sub_master + "&store=" + values.store, values.sub_master && values.store);
    const productListIssueOptions = ProductSalesOptions(pro_member_data?.products);
    const productStoreOptions = ProductStoreOptions(sub_category?.product_store || []);
    const [isFetching, setIsFetching] = useState(false);
    const REQUEST_TIMEOUT = 100;
    const handleKeyPress = async (event: any) => {
        if (event.key === "Enter" && !isFetching) {
            setIsFetching(true);
            setTimeout(() => {
                setIsFetching(false);
            }, REQUEST_TIMEOUT);
            try {
                await fetchDataFromApi(AppURL.InventoryURL + "inventory/product/member/search/report/list/?member_sn=" + values.member_sn).then((res) => {
                    setOnEmployeeData(res);
                    console.log(res)
                    onClose(true);
                });
            } catch (error: any) {
                alert(error.response.detail)
            }
        }
    };

    useEffect(() => {
        const totalProductAmt = parseFloat(values.sales_rate || "0") * parseFloat(values.sales_qty || "0");
        const vatAmt = totalProductAmt * parseFloat(values.vat_amt || "0") / 100;
        const totalWithVat = totalProductAmt + vatAmt;
        const totalDisPerc = totalWithVat * parseFloat(values.dis_per || "0") / 100;
        const totalFinalAmt = (totalWithVat - totalDisPerc) - parseFloat(values.dis_amt || "0");
        setOnAmtList({
            total_product_amt: totalProductAmt,
            vatAmt: vatAmt,
            final_total_amt: totalFinalAmt,
        });
        setFieldValue("sel_tot_amt", onAmtList?.final_total_amt)
    }, [values.sales_qty, values.sales_rate, values.vat_amt, onAmtList?.final_total_amt, values.dis_amt, values.dis_per]);

    const handleSaveSubmit = async () => {
        await salesDataPost(SalesProductList, dispatch);
        await refetch();
      };
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Add Sales Product' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <DefaultSelectInputBox
                            label='Master Category'
                            options={masterCategoryOptions}
                            name='master_category'
                            required={true}
                            placeholder='Select meter status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            disabled
                            handleBlur={() => {
                                handleBlur({ target: { name: 'master_category' } });
                            }}
                            value={values.master_category}
                            touched={touched.master_category}
                            errors={errors.master_category}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Product Category'
                            options={subCategoryOptions}
                            name='sub_master'
                            required={true}
                            placeholder='Select Product Category'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'sub_master' } });
                            }}
                            value={values.sub_master}
                            touched={touched.sub_master}
                            errors={errors.sub_master}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            label='Product Store'
                            options={productStoreOptions}
                            name='store'
                            required={true}
                            placeholder='Select Product Store'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'store' } });
                            }}
                            
                            value={values.store}
                            touched={touched.store}
                            errors={errors.store}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            label='Product'
                            options={productListIssueOptions}
                            name='product'
                            required={true}
                            disabled={!values.store || !values.sub_master}
                            isLoading={pro_member_loading}
                            placeholder='Select Product'
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("pro_name", selectedOption.label);
                                setFieldValue("sales_qty", '');
                                setFieldValue("sales_rate", selectedOption.sale_rate);
                                setFieldValue("vat_amt", selectedOption.vat_perc);
                                setFieldValue("dis_amt", selectedOption.disc_amt);
                                setFieldValue("dis_per", selectedOption.disc_perc);
                                setFieldValue("total_purchase", selectedOption.total_purchase);
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'product' } });
                            }}
                            value={values.product}
                            touched={touched.product}
                            errors={errors.product}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='number'
                            name='sales_qty'
                            label='Sales QTY'
                            handleChange={handleChange}
                            value={values.sales_qty}
                            error={errors.sales_qty?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.sales_qty ? Boolean(touched.sales_qty) : undefined}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='number'
                            name='member_sn'
                            label='Member SN'
                            handleChange={handleChange}
                            onKeyPress={handleKeyPress}
                            value={values.member_sn}
                            error={errors.member_sn?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.member_sn ? Boolean(touched.member_sn) : undefined}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SalesDetailsDrawer handleSubmit={handleSubmit} values={values} open={open} onClose={onClose} employeeData={employeeData || defaultEmployeeData} totalProductAmt={0} vatPerc={0} disAmt={0} disPerc={0} finalTotalAmt={0} />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={0}>
                            <Button btn_type='save' onClick={handleSaveSubmit} type='button' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ProductSaleCreateView